import React, { useState } from 'react'
import TukutukuBackground from '../icons/TukutukuBackground'
import { useAppSelector } from '../../utils/storeHooks';
import StayInformedForm from '../body/StayInformedForm';
import ChevronRight from '../icons/ChevronRight';
import { Link } from 'react-router-dom';

const HomePage = () => {

    const { lang } = useAppSelector(store => store.display);
    const [ formIsVisible, setFormIsVisible ] = useState(true);
    const isMāori = lang === 'ma';

    const toggleFormVisibility = () => {
        setFormIsVisible(!formIsVisible)
    }

    const pageBody = {
        ma: {
            tahi: 'Kei te whakaritea tonutia tēnei wāhi hei pae whakawhitiwhiti reo mā tātou, te hunga kōrero Māori. He wāhi tuku pātai, tuku whakaaro hoki, e tipu ai ngā kupu tika kia puāwai ko te reo i ngā kokonga katoa o tō tātou ao (',
            link: 'pāwhiri ki konei ki te pānui ake',
            tahiWhakakapi: ').',
            rua: 'Mehemea e pīranga ana koe ki te rongo i te karanga hei te wā e hika ai te ahi wānanga, tukuna mai tāu īmērā ki raro nei.',
            success1: 'Kua ū tō īmēra!',
            success2: 'Taihoa ka whiwhi i tā mātou karere!',
            anō: "Tāpiri anō",
        },
        en: {
            tahi: 'This space is being prepared for us, as speakers of te reo Māori, to share our reo. It is a place where we can develop ideas, ask questions and grow the right kupu to fit every situation in our lives (',
            link: 'click here to learn more',
            tahiWhakakapi: ').',
            rua: 'If you would like us to let you know when the space is ready for wānanga, send us your email address below.',
            success1: "Ka pai - we've got your email address!",
            success2: "We'll let you know when tukutuku is ready to go.",
            anō: "Add another",
        },
    }


    return (
        <>
            <TukutukuBackground />
            <div className='bodyHeight flex flex-col items-center w-full z-0 px-4 bg-linear-to-b from-kaho-2 via-[#E2DFD6CC] via-80% to-[#E2DFD644] overflow-scroll'>
                <div className="md:w-[60vw]">
                    <div className='pt-2 pb-4 md:pb-8 md:pt-4'>
                        <h1 className='text-center w-full text-5xl md:text-6xl lg:text-7xl 2xl:text-8xl'>tukutuku</h1>
                        <p className='text-center'>tō auaha kia reo, tō ao kia mārama</p>
                    </div>
                    <div className="relative">
                        <div>
                            <p className='text-left paragraph'>
                                Kia ora e te whanaunga. Ka mihi ki a koe i tāu pekanga mai. 
                            </p>
                            <p className='text-left paragraph'>
                                {pageBody[lang].tahi}
                                <Link to='/about' className='textLink'>{pageBody[lang].link}</Link>
                                {pageBody[lang].tahiWhakakapi}
                            </p>
                            <p className='text-left paragraph'>
                                {pageBody[lang].rua}
                            </p>
                        </div>
                    </div>
                </div>
                {
                    formIsVisible ?
                        <StayInformedForm reo={isMāori} toggleForm={toggleFormVisibility} />
                    :
                        <div className='pt-2 md:mt-4 flex-whenu'>
                            <h3>{pageBody[lang].success1}</h3>
                            <p>{pageBody[lang].success2}</p>
                            <div className='flex-aho-reverse w-full mt-4'>
                                <button type='button' className='bg-toto-0 pl-3 pr-2 py-1 flex-aho cursor-pointer group transition-slow hover:scale-105' onClick={toggleFormVisibility}>
                                    <p className='text-kaho-1 font-normal inline transition-slow'>{pageBody[lang].anō}</p>
                                    <ChevronRight style='text-kaho-1 size-6 transition-slow group-hover:scale-110 group-hover:translate-x-1' />
                                </button>
                            </div>
                        </div>
                }
            </div>
        </>
        
    )
}

export default HomePage